export default {
  LATITUDE_TEMPLATE_SLUG: 'ws-intense-next',
  LEGACY_TEMPLATE_SLUG: 'ws-intense',
};
